/* Small Featured short display for the sidebar */

import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Image from 'next/image';
import {pickImageStyle} from '../../../utils/transforms';

const useStyles = makeStyles((theme) => ({
      featuredArticle: {
        position: 'relative',
        '&:hover': {
          opacity: .9,
        },
      },
      featuredArticleImage: {
        width: 100,
        marginLeft: 8,
        maxHeight: 40,
      },
      featuredArticleTitle: {
        fontSize: 18,
        lineHeight: '1.4',
      },
      coverLink: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 20,
      },
    }),
);

export default function FeaturedArticle(props) {
  const classes = useStyles(props);
  const {node} = props;
  let {
    rest_alias,
    alias,
    internal,
    title,
    imgWidth,
    imgHeight,
    imgAlt,
    imageOrig,
    imgTitle,
    image_styles
  } = node;

  const getImageStyle = pickImageStyle(
      {
        imgAlt: imgAlt || address,
        imgTitle: imgTitle || address,
        imgWidth,
        imgHeight,
        imageOrig,
        image_styles,
        title,
      },
      'max_100_width',
  );
  ({imgAlt, imgTitle, imgWidth, imgHeight, imageOrig} = getImageStyle);

  let node_url = rest_alias || alias || internal;

  return (
      <Box bgcolor="success.main" py={1} my={1}
           className={classes.featuredArticle}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            {imageOrig &&
            <Box pl={1}>
              <Image width="770" height="320" style={{layout: 'responsive'}}
                     sizes="60vw" className={classes.featuredArticleImage}
                     src={imageOrig}
                     alt={imgAlt} title={imgTitle}/>
            </Box>
            }
          </Grid>
          <Grid item xs={8}>
            <Typography
                className={classes.featuredArticleTitle}>{title}</Typography>
            <Link className={classes.coverLink} href={node_url}>
              <Typography variant="srOnly">Read full article</Typography>
            </Link>
          </Grid>
        </Grid>
      </Box>
  );
};
